// V4 accounts have no reference or language field; both live in settings.
export const V4_ACCOUNT_REFERENCE_SETTING = 'reference';
export const V4_ACCOUNT_LANGUAGE_SETTING = 'language';

// Undefined when unset, so the Account defaults apply.
export const storedV4AccountReference = settings => settings?.[V4_ACCOUNT_REFERENCE_SETTING] || undefined;
export const storedV4AccountLanguage = settings => settings?.[V4_ACCOUNT_LANGUAGE_SETTING] || undefined;

// null keeps the stored value; an emptied reference is removed.
export function withV4AccountProfile(settings, {reference = null, language = null} = {}) {
  const next = {...(settings || {})};
  if (reference !== null) {
    if (reference) next[V4_ACCOUNT_REFERENCE_SETTING] = reference;
    else delete next[V4_ACCOUNT_REFERENCE_SETTING];
  }
  if (language) next[V4_ACCOUNT_LANGUAGE_SETTING] = language;
  return next;
}
